import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderBannerComponent } from './slider-banner.component';
import { SwiperModule } from 'swiper/angular';



@NgModule({
  declarations: [SliderBannerComponent],
  imports: [
    CommonModule,
    SwiperModule
  ],
  exports: [
    SliderBannerComponent
  ]
})
export class SliderBannerModule { }
